import $ from 'jquery';
import asimov from '../core';
import Modal from './lib/modal-lib';

var pluginName = 'modal',
    modals = {},
    defaults = {
        name: '',
        content: '',
        animation: 'fade',
        scroll: 'wrapper',
        class: '',
        variations: '',
        closeable: true,
    };

function build(options, elem) {
    var obj = new Modal(modals).init(options, elem);

    // Public API

    return {
        show: function() {
            obj.show();
            return this;
        },

        hide: function() {
            obj.hide();
            return this;
        },

        stop: function() {
            obj.stop();
            return this;
        },

        proceed: function() {
            obj.proceed();
            return this;
        },

        closeable: function(canClose) {
            obj.closeable(canClose);
            return this;
        },

        canProceed: function() {
            return obj.canProceed();
        },

        getName: function() {
            return obj.getName();
        },

        getContent: function() {
            return obj.getContent();
        },

        getTrigger: function() {
            return obj.getTrigger();
        },
    };
}

// Plugin definition

$.fn[pluginName] = function(options) {
    return this.each(function() {
        if (!$.data(this, pluginName)) {
            var opts = asimov.mergeElementData(
                $(this),
                pluginName,
                $.extend(true, {}, defaults, options)
            );

            $.data(this, pluginName, build(opts, this));
        }
    });
};



// WEBPACK FOOTER //
// ./~/@99designs/asimov/modal/index.js